// @ts-nocheck
import LoadingIndicator from 'app/components/LoadingIndicator';
import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const WechatOAPage = () => {
  const searchParams = useLocation().search;
  const [invokeData, setInvokeData] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const paramTid = new URLSearchParams(searchParams).get('tid');
  const redirectUrl = new URLSearchParams(searchParams).get('redirectUrl');

  const onBridgeReady = useCallback(data => {
    if (!data || !window.WeixinJSBridge) return;

    WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        setMessage(res.err_msg);
        navigate(`/confirm?tid=${paramTid}`);
        // 필요 시 리디렉션 또는 상태 업데이트
      } else {
        setMessage(res.err_msg);
        const cancelUrl = `${redirectUrl}?returnValue=${res.err_msg}`;
        window.location.href = cancelUrl;
      }
    });
  }, []);

  // 1. URL 파라미터에서 데이터 추출
  useEffect(() => {
    const data = new URLSearchParams(searchParams).get('data');
    if (data) {
      try {
        const parsed = JSON.parse(decodeURIComponent(data));
        setInvokeData(parsed);
      } catch (err) {
        console.error('❌ JSON 파싱 오류:', err);
      }
    }
  }, [searchParams]);

  // 2. invokeData가 준비된 후 브리지 준비 상태 확인 및 처리
  useEffect(() => {
    if (!invokeData) return;

    const handleBridge = () => onBridgeReady(invokeData);

    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', handleBridge, false);
        return () =>
          document.removeEventListener('WeixinJSBridgeReady', handleBridge);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', handleBridge);
        document.attachEvent('onWeixinJSBridgeReady', handleBridge);
        return () => {
          document.detachEvent('WeixinJSBridgeReady', handleBridge);
          document.detachEvent('onWeixinJSBridgeReady', handleBridge);
        };
      }
    } else {
      handleBridge();
    }
  }, [invokeData, onBridgeReady]);

  return <LoadingIndicator />;
};

export default WechatOAPage;
